import { Action, Dispatch } from "redux";
import axios from "../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../config/constants";
import * as action_types from "./constants";
import { CoordinatesType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const processLatLngs = (payload: CoordinatesType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(`${baseURL}processLatLngs`, payload);
      dispatch({
        type: action_types.GET_DRIVE_TIME,
        data: { payload: data?.driveTimes, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_DRIVE_TIME,
        data: {},
      });
    }
  };
};

export const removeLatLngs = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.GET_DRIVE_TIME,
      data: { payload: [], loading: true },
    });
  };
};

export const schedulingFilters = () => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}schedulingFilters`);
      dispatch({
        type: action_types.SCHEDULING_FILTERS,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.SCHEDULING_FILTERS,
        payload: { loading: false },
      });
    }
  };
};

export const getSchedulingFormData = (payload: { date: string }) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getSchedulingFormData`,
        payload
      );
      dispatch({
        type: action_types.GET_SCHEDULING_FORM_DATA,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_SCHEDULING_FORM_DATA,
        payload: { loading: false },
      });
    }
  };
};

export const getScheduleByDay = (date: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getScheduleByDay/${date}`);
      dispatch({
        type: action_types.GET_SCHEDULE_BY_DAY,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_SCHEDULE_BY_DAY,
        payload: { loading: false },
      });
    }
  };
};

export const getScheduleByWeek = (date: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getScheduleByWeek/${date}`);
      dispatch({
        type: action_types.GET_SCHEDULE_BY_WEEK,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_SCHEDULE_BY_WEEK,
        payload: { loading: false },
      });
    }
  };
};

export const getWeatherByWeek = () => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getWeatherByWeek`);
      dispatch({
        type: action_types.GET_WEATHER_BY_WEEK,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.GET_WEATHER_BY_WEEK,
        payload: { loading: false },
      });
    }
  };
};
